// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-menu-custom {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
  min-width: 300px;
}
.dropdown-menu-custom .dropdown-option {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;
}
.dropdown-menu-custom .dropdown-option.active, .dropdown-menu-custom .dropdown-option:hover {
  background-color: #f8f9fa;
}
.dropdown-menu-custom .dropdown-option:last-child {
  border-bottom: none;
  border-radius: 0 0 8px 8px;
}
.dropdown-menu-custom .dropdown-option .option-content {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
}
.dropdown-menu-custom .dropdown-option .option-content .location-pin-icon {
  color: #333;
  font-size: 14px;
  flex-shrink: 0;
}
.dropdown-menu-custom .dropdown-option .option-content .favorite-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #ddd;
  transition: color 0.2s ease;
  flex-shrink: 0;
}
.dropdown-menu-custom .dropdown-option .option-content .favorite-btn:hover {
  color: #ffc107;
}
.dropdown-menu-custom .dropdown-option .option-content .favorite-btn.active {
  color: #ffc107;
}
.dropdown-menu-custom .dropdown-option .option-content .favorite-btn i {
  font-size: 14px;
}
.dropdown-menu-custom .dropdown-option .option-content .option-text {
  flex: 1;
}
.dropdown-menu-custom .dropdown-option .option-content .option-text .option-code {
  font-weight: 600;
  color: #333;
  font-size: 14px;
  line-height: 1.2;
  margin-bottom: 2px;
}
.dropdown-menu-custom .dropdown-option .option-content .option-text .option-address {
  font-size: 12px;
  color: #666;
  line-height: 1.3;
}

.location-dropdown .location-input-group .location-input {
  border-right: none;
}
.location-dropdown .location-input-group .location-input:focus {
  border-color: #007bff;
  box-shadow: none;
}
.location-dropdown .location-input-group .location-input:focus + .search-btn,
.location-dropdown .location-input-group .location-input:focus + .del-btn {
  border-color: #007bff !important;
  box-shadow: none;
}
.location-dropdown .location-input-group .search-btn,
.location-dropdown .location-input-group .del-btn {
  border-left: none;
  background-color: white;
  border: 1px solid var(--bs-border-color) !important;
  border-left: 0 !important;
}
.location-dropdown .location-input-group .search-btn:focus,
.location-dropdown .location-input-group .del-btn:focus {
  border-color: #007bff !important;
  box-shadow: none !important;
}
.location-dropdown .location-input-group .search-btn .fa-search:hover {
  cursor: text;
}
.location-dropdown .location-input-group .search-btn .fa-times:hover {
  cursor: pointer;
}
.location-dropdown .add-btn-separate {
  margin-left: 8px;
  background-color: white;
  border: 1px solid var(--bs-border-color) !important;
}
.location-dropdown .add-btn-separate:hover, .location-dropdown .add-btn-separate:focus {
  background-color: #f8f9fa;
  border: 1px solid var(--bs-border-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/components/Controls/LocationDropdown/styles.scss"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,sCAAA;AAAJ;AAEI;EAEE,yBAAA;AADN;AAII;EACE,mBAAA;EACA,0BAAA;AAFN;AAKI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;AAHN;AAKM;EACE,WAAA;EACA,eAAA;EACA,cAAA;AAHR;AAMM;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,cAAA;AAJR;AAMQ;EACE,cAAA;AAJV;AAOQ;EACE,cAAA;AALV;AAQQ;EACE,eAAA;AANV;AAUM;EACE,OAAA;AARR;AAUQ;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AARV;AAWQ;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AATV;;AAmBI;EACE,kBAAA;AAhBN;AAkBM;EACE,qBAAA;EACA,gBAAA;AAhBR;AAiBQ;;EAEE,gCAAA;EACA,gBAAA;AAfV;AAoBI;;EAEE,iBAAA;EACA,uBAAA;EACA,mDAAA;EACA,yBAAA;AAlBN;AAoBM;;EACE,gCAAA;EACA,2BAAA;AAjBR;AAqBM;EACE,YAAA;AAnBR;AAqBM;EACE,eAAA;AAnBR;AAwBE;EACE,gBAAA;EACA,uBAAA;EACA,mDAAA;AAtBJ;AAwBI;EAEE,yBAAA;EACA,mDAAA;AAvBN","sourcesContent":["// Dropdown menu styles - needs to be global since it's rendered in a portal\n.dropdown-menu-custom {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  max-height: 300px;\n  overflow-y: auto;\n  min-width: 300px;\n\n  .dropdown-option {\n    display: flex;\n    align-items: center;\n    padding: 12px 16px;\n    cursor: pointer;\n    border-bottom: 1px solid #f0f0f0;\n    transition: background-color 0.2s ease;\n\n    &.active,\n    &:hover {\n      background-color: #f8f9fa;\n    }\n\n    &:last-child {\n      border-bottom: none;\n      border-radius: 0 0 8px 8px;\n    }\n\n    .option-content {\n      display: flex;\n      align-items: center;\n      width: 100%;\n      gap: 8px;\n\n      .location-pin-icon {\n        color: #333;\n        font-size: 14px;\n        flex-shrink: 0;\n      }\n\n      .favorite-btn {\n        background: none;\n        border: none;\n        cursor: pointer;\n        padding: 4px;\n        color: #ddd;\n        transition: color 0.2s ease;\n        flex-shrink: 0;\n\n        &:hover {\n          color: #ffc107;\n        }\n\n        &.active {\n          color: #ffc107;\n        }\n\n        i {\n          font-size: 14px;\n        }\n      }\n\n      .option-text {\n        flex: 1;\n\n        .option-code {\n          font-weight: 600;\n          color: #333;\n          font-size: 14px;\n          line-height: 1.2;\n          margin-bottom: 2px;\n        }\n\n        .option-address {\n          font-size: 12px;\n          color: #666;\n          line-height: 1.3;\n        }\n      }\n    }\n  }\n}\n\n.location-dropdown {\n  // Override for input group within dropdown\n  .location-input-group {\n    .location-input {\n      border-right: none;\n\n      &:focus {\n        border-color: #007bff;\n        box-shadow: none;\n        + .search-btn,\n        + .del-btn {\n          border-color: #007bff !important;\n          box-shadow: none;\n        }\n      }\n    }\n\n    .search-btn,\n    .del-btn {\n      border-left: none;\n      background-color: white;\n      border: 1px solid var(--bs-border-color) !important;\n      border-left: 0 !important;\n\n      &:focus {\n        border-color: #007bff !important;\n        box-shadow: none !important;\n      }\n    }\n    .search-btn {\n      .fa-search:hover {\n        cursor: text;\n      }\n      .fa-times:hover {\n        cursor: pointer;\n      }\n    }\n  }\n\n  .add-btn-separate {\n    margin-left: 8px;\n    background-color: white;\n    border: 1px solid var(--bs-border-color) !important;\n\n    &:hover,\n    &:focus {\n      background-color: #f8f9fa;\n      border: 1px solid var(--bs-border-color) !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
